export class Invoicing {
    static getInvoiceNumber({ prefix, number, numberLen, suffix, }) {
        return `${prefix ?? ""}${String(number ?? 0).padStart(numberLen ?? 1, "0")}${suffix ?? ""}`;
    }
}
//# sourceMappingURL=invoicing.js.map